import React from "react";

const UserAgreementPage = () => {
  return (
    <main className="container mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">Условия пользовательского соглашения</h1>
      </header>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
        <p className="mb-4">
          Настоящее Пользовательское соглашение (далее – Соглашение) регулирует отношения между интернет-магазином «Vanil» (далее – Магазин) и пользователями сайта. Используя данный сайт, вы соглашаетесь с условиями настоящего Соглашения.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">2. Предмет соглашения</h2>
        <p className="mb-4">
          Магазин предоставляет пользователю возможность просматривать ассортимент косметических товаров, оформлять заказы и получать информацию о продуктах. Все услуги предоставляются на условиях, изложенных в данном Соглашении.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">3. Права и обязанности сторон</h2>
        <p className="mb-4">
          <strong>Пользователь обязуется:</strong> предоставлять достоверные данные при регистрации и оформлении заказа, соблюдать правила пользования сайтом, а также не использовать информацию сайта в коммерческих целях без согласия Магазина.
        </p>
        <p className="mb-4">
          <strong>Магазин обязуется:</strong> обеспечивать доступ к сайту, защищать персональные данные пользователей и своевременно информировать об изменениях условий предоставления услуг.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">4. Ответственность сторон</h2>
        <p className="mb-4">
          Магазин не несет ответственности за невозможность выполнения обязательств, возникшую по причинам, не зависящим от него, а также за убытки, причиненные неправильным использованием информации, размещенной на сайте.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">5. Прочие условия</h2>
        <p className="mb-4">
          Настоящее Соглашение является публичной офертой. Все споры, возникающие в связи с его выполнением, подлежат рассмотрению в соответствии с действующим законодательством Республикой Казахстан. При несогласии с условиями Соглашения пользователь обязан прекратить использование сайта.
        </p>
      </section>
    </main>
  );
};

export default UserAgreementPage;
